export default "__VITE_ASSET__ce776fe5__"